"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ACTIVITY_TYPES: 'ACTIVITY_TYPES',
  ADS_PROPERTIES: 'ADS_PROPERTIES',
  ADS_FACEBOOK_ADGROUPS: 'ADS_FACEBOOK_ADGROUPS',
  ADS_FACEBOOK_ADS: 'ADS_FACEBOOK_ADS',
  ADS_FACEBOOK_CAMPAIGNS: 'ADS_FACEBOOK_CAMPAIGNS',
  ADS_GOOGLE_ADGROUPS: 'ADS_GOOGLE_ADGROUPS',
  ADS_GOOGLE_ADS: 'ADS_GOOGLE_ADS',
  ADS_GOOGLE_CAMPAIGNS: 'ADS_GOOGLE_CAMPAIGNS',
  ADS_GOOGLE_KEYWORDS: 'ADS_GOOGLE_KEYWORDS',
  ADS_LINKEDIN_ADGROUPS: 'ADS_LINKEDIN_ADGROUPS',
  ADS_LINKEDIN_ADS: 'ADS_LINKEDIN_ADS',
  ADS_LINKEDIN_CAMPAIGNS: 'ADS_LINKEDIN_CAMPAIGNS',
  ALL_WORKFLOWS: 'ALL_WORKFLOWS',
  ANALYTICS_VIEWS: 'ANALYTICS_VIEWS',
  APP_USERS: 'APP_USERS',
  AUTOMATION_PLATFORM_WORKFLOWS: 'AUTOMATION_PLATFORM_WORKFLOWS',
  BLOG_POSTS: 'BLOG_POSTS',
  BLOGS: 'BLOGS',
  BLOG_AUTHOR: 'BLOG_AUTHOR',
  BLOG_TAG: 'BLOG_TAG',
  BROADCASTS: 'BROADCASTS',
  CALL_DISPOSITIONS: 'CALL_DISPOSITIONS',
  CAMPAIGNS: 'CAMPAIGNS',
  COMPANIES_SAVED_FILTERS: 'COMPANIES_SAVED_FILTERS',
  COMPANIES: 'COMPANIES',
  COMPANY_PROPERTIES: 'COMPANY_PROPERTIES',
  CONTACTS_BY_EMAIL: 'CONTACTS_BY_EMAIL',
  CONTACT_LISTS: 'CONTACT_LISTS',
  CONTACT_PROPERTIES: 'CONTACT_PROPERTIES',
  CONTACT_STATIC_LISTS: 'CONTACT_STATIC_LISTS',
  CONTACTS_SAVED_FILTERS: 'CONTACTS_SAVED_FILTERS',
  CONTACTS: 'CONTACTS',
  CTAS: 'CTAS',
  CTA_TO_PLACEMENT: 'CTA_TO_PLACEMENT',
  DEALS_SAVED_FILTERS: 'DEALS_SAVED_FILTERS',
  DEALS: 'DEALS',
  DEAL_PIPELINES: 'DEAL_PIPELINES',
  DEAL_PIPELINE_STAGES: 'DEAL_PIPELINE_STAGES',
  DEAL_PROPERTIES: 'DEAL_PROPERTIES',
  ECOMMERCE_APPS: 'ECOMMERCE_APPS',
  ECOMMERCE_STORES: 'ECOMMERCE_STORES',
  EMAILS: 'EMAILS',
  EMAIL_CAMPAIGNS: 'EMAIL_CAMPAIGNS',
  EMAIL_CAMPAIGN_URLS: 'EMAIL_CAMPAIGN_URLS',
  EMAIL_SUBSCRIPTIONS: 'EMAIL_SUBSCRIPTIONS',
  ENGAGEMENTS: 'ENGAGEMENTS',
  ENGAGEMENT_PROPERTIES: 'ENGAGEMENT_PROPERTIES',
  EVENTS: 'EVENTS',
  FEEDBACK_FORMS: 'FEEDBACK_FORMS',
  FEEDBACK: 'FEEDBACK',
  FORMS: 'FORMS',
  HIERARCHICAL_TEAMS: 'HIERARCHICAL_TEAMS',
  IMPORT_NAMES: 'IMPORT_NAMES',
  INBOUND_DB_COMPANY_IMPORT: 'INBOUND_DB_COMPANY_IMPORT',
  INBOUND_DB_CONTACT_IMPORT: 'INBOUND_DB_CONTACT_IMPORT',
  INBOUND_DB_DEAL_IMPORT: 'INBOUND_DB_DEAL_IMPORT',
  INTEGRATIONS: 'INTEGRATIONS',
  INTEGRATION_NAMES: 'INTEGRATION_NAMES',
  INTEGRATION_PROPERTIES: 'INTEGRATION_PROPERTIES',
  KNOWLEDGE_ARTICLES: 'KNOWLEDGE_ARTICLES',
  LANDING_PAGES: 'LANDING_PAGES',
  LEAD_FLOWS: 'LEAD_FLOWS',
  LINE_ITEMS: 'LINE_ITEMS',
  LINE_ITEM_PROPERTIES: 'LINE_ITEM_PROPERTIES',
  MULTI_CURRENCY_CURRENCY_CODES: 'MULTI_CURRENCY_CURRENCY_CODES',
  MULTI_CURRENCY_INFORMATION: 'MULTI_CURRENCY_INFORMATION',
  OWNERS: 'OWNERS',
  PERSONAS: 'PERSONAS',
  PIPELINES: 'PIPELINES',
  PRODUCTS: 'PRODUCTS',
  PRODUCT_FOLDERS: 'PRODUCT_FOLDERS',
  PRODUCT_PROPERTIES: 'PRODUCT_PROPERTIES',
  PROPERTY_GROUPS: 'PROPERTY_GROUPS',
  QUOTES: 'QUOTES',
  QUOTE_PROPERTIES: 'QUOTE_PROPERTIES',
  SALESFORCE_CAMPAIGNS: 'SALESFORCE_CAMPAIGNS',
  SALESFORCE_CAMPAIGN_LISTS: 'SALESFORCE_CAMPAIGN_LISTS',
  SITE_CONTENT: 'SITE_CONTENT',
  SITE_PAGES: 'SITE_PAGES',
  SLACK_CHANNEL: 'SLACK_CHANNEL',
  SLACK_USER: 'SLACK_USER',
  SNIPPETS: 'SNIPPETS',
  SURVEY_QUESTIONS: 'SURVEY_QUESTIONS',
  SURVEY_SETTINGS: 'SURVEY_SETTINGS',
  SURVEYS: 'SURVEYS',
  TASKS: 'TASKS',
  TEAMS: 'TEAMS',
  TICKETS: 'TICKETS',
  TICKET_PIPELINES: 'TICKET_PIPELINES',
  TICKET_PROPERTIES: 'TICKET_PROPERTIES',
  USERS: 'USERS',
  WEBINARS: 'WEBINARS',
  WEBINAR_SETTINGS: 'WEBINAR_SETTINGS',
  WORKFLOWS: 'WORKFLOWS',
  WORKFLOWS_SALESFORCE: 'WORKFLOWS_SALESFORCE'
};
exports.default = _default;
module.exports = exports.default;